import React, { useState } from "react";
import axios from "axios";

function DemandeResetMdp() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);
    try {
      await axios.post("https://appapi.unpaidfinancial.com/api/forgot-password", { email });
      setMessage("Un email de réinitialisation a été envoyé à l'adresse.");
    } catch (e) {
      setError("Erreur lors de l'envoi. Essayez encore.");
    }
    setLoading(false);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 bg-gray-100">
      <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-6 text-blueGray-800">Mot de passe oublié</h2>
        {message && <div className="mb-4 text-green-600">{message}</div>}
        {error && <div className="mb-4 text-red-600">{error}</div>}
        <form onSubmit={handleSubmit}>
          <label className="block mb-2 font-medium">Adresse email</label>
          <input
            type="email"
            className="w-full p-3 rounded border mb-4"
            placeholder="Votre email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <button
            type="submit"
            className="w-full bg-blueGray-800 hover:bg-blueGray-600 text-white font-bold py-2 rounded transition"
            disabled={loading}
          >
            {loading ? "Envoi..." : "Envoyer"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default DemandeResetMdp;
